import { sessionState } from '../auth/session-state';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { LoginService } from '../login/login.service';
import { Routes, RouterModule, Router } from '@angular/router';
import * as myGlobalsfunc from '../global.function';
import { NgxSpinnerService } from 'ngx-spinner';
// Translation services
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  // Function and varuiables Decleration
  @ViewChild('emailFocus') emailName: ElementRef;
  loginForm: UntypedFormGroup;
  submitted = false;
  public msgtype: Boolean = false;
  displayLogout = false;
  public showMessageDiv: any;
  public showmessage: any;
  public contentLogout: any;
  public logoutUserId: any;
  public msgs = [];
  public token: any;
  // Constructor
  constructor(
    private spinner: NgxSpinnerService,
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginService,
    private router: Router,
    private authService: AuthService,
    // Translator service Injection
    private translate: TranslateService
  ) {
    translate.setDefaultLang('en');

    if (this.authService.isLoggedIn()) {
      if (
        sessionState.getItem('sadm') &&
        Number(sessionState.getItem('sadm')) === 1
      ) {
        if (
          sessionState.getItem('lac') &&
          Number(sessionState.getItem('lac')) > 0
        ) {
          this.router.navigate(['']);
        } else {
          this.router.navigate(['/system-admin']);
        }
      } else {
        this.router.navigate(['']);
      }
    }
  }
  useLanguage(language: string) {
    this.translate.use(language);
  }
  // Return the form controls
  get f() {
    return this.loginForm.controls;
  }

  // fn: show error
  showError(type, message) {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: message });
  }

  // Invoked the time the component loads
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern('^([a-zA-Z0-9_.\-]+)@([a-zA-Z0-9_.\-]+)[.]([a-zA-Z]{2,})$'), Validators.maxLength(255)]
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.minLength(8)
        ]
      ]
    });
    setTimeout(() => {
      this.emailName.nativeElement.focus();
    }, 500);
  }
  // Disable the copy and paste option
  disablePaste(e) {
    e.preventDefault();
  }
  // After init this function runs and keeps the focus on the email element
  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.emailName.nativeElement.focus();
  }

  onCancelModal() {
    this.displayLogout = false;
  }

  onConfirmnation() {
    this.spinner.show();
    // Method to remove old user session
    this.loginService
      .logoutSession({ user_id: this.logoutUserId, token: this.token })
      .subscribe(
        (res: any) => {
          this.displayLogout = false;
          this.spinner.hide();
          // if the response status is 1 the user is sucessfully logout else show error message
          if (res.status === 1) {
            window.scroll(0, 0);
            this.showError('success', res.message);
            // this.showmessage = res.message;
          } else {
            window.scroll(0, 0);
            this.showError('error', res.message);
          }
        },
        // Log any error occured in logout session
        error => {
          this.showError('error', error);
        }
      );
  }

  // On secessfull form validation invoke this function
  onSubmit() {
    this.submitted = true;
    this.spinner.show();
    this.showmessage = '';
    this.showMessageDiv = false;
    this.msgs = [];
    this.msgtype = false;
    // stop here if loginForm is invalid
    if (this.loginForm.invalid) {
      return;
    }
    // Method to validate user login
    this.loginService.loginValidation(this.loginForm.value).subscribe(
      (res: any) => {
        this.submitted = false;
        // if the response status is 1 the user is sucessfully logged in else show error message
        if (res.status === 1) {
          // save the session in the local storage
          sessionState.setItem('access_token', res.user.data.access_token);
          sessionState.setItem('expires_in', res.user.data.expires_in);
          sessionState.setItem('id_token', res.user.data.id_token);
          sessionState.setItem('user_id', res.user.user_id);
          if (res.user.isSystemAdmin) {
            sessionState.setItem('sadm', 1);
          }

          if(res.user.mfa_required && !res.user.mfa_passed) {
            sessionState.setItem('mfa_required', 1);
            sessionState.setItem('mfa_passed', 0);
            this.router.navigate(['/mfa-challenge']);
          } else {
            if (res.user.isSystemAdmin) {
              this.router.navigate(['/system-admin']);
            } else {
              this.router.navigate(['']);
            }
          }
        } else if (res.status === 2) {
          this.displayLogout = true;
          this.logoutUserId = res.user_id;
          this.token = res.token;
          this.submitted = false;
          this.contentLogout = res.message;
          this.spinner.hide();
        } else if (res.status === 0) {
          window.scroll(0, 0);
          this.showMessageDiv = true;
          this.submitted = false;
          this.showError('error', res.message);
          this.showmessage = res.message;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
        this.submitted = false;
      },
      // Log any error occured in logging in
      error => {
        this.showError('error', error);
      }
    );
  }
}
